// Sync
export const KEEPER_SYNC_STARTED = 'KEEPER_SYNC_STARTED'
export const KEEPER_SYNC_STATUS_UPDATED = 'KEEPER_SYNC_STATUS_UPDATED'
export const KEEPER_SYNC_COMPLETE = 'KEEPER_SYNC_COMPLETE'
export const KEEPER_SYNC_ERROR = 'KEEPER_SYNC_ERROR'
export const KEEPER_SYNC_RESET = 'KEEPER_SYNC_RESET'

// Dashboard
export const KEEPER_RECON_LOADING = 'KEEPER_RECON_LOADING'
export const KEEPER_RECON_REPORT_LOADED = 'KEEPER_RECON_REPORT_LOADED'
export const KEEPER_RECON_REPORT_FAILED = 'KEEPER_RECON_REPORT_FAILED'
export const KEEPER_RECON_EXECUTING = 'KEEPER_RECON_EXECUTING'
export const KEEPER_RECON_EXECUTED = 'KEEPER_RECON_EXECUTED'
export const KEEPER_RECON_EXECUTE_FAILED = 'KEEPER_RECON_EXECUTE_FAILED'
export const KEEPER_RECON_ROW_UPDATING = 'KEEPER_RECON_ROW_UPDATING'
export const KEEPER_RECON_ROW_UPDATED = 'KEEPER_RECON_ROW_UPDATED'
export const KEEPER_RECON_ROW_UPDATE_FAILED = 'KEEPER_RECON_ROW_UPDATE_FAILED'
export const KEEPER_RECON_ROW_APPROVED = 'KEEPER_RECON_ROW_APPROVED'
export const KEEPER_RECON_ROW_RESOLVED = 'KEEPER_RECON_ROW_RESOLVED'
export const KEEPER_RECON_COMPANIES_LOADED = 'KEEPER_RECON_COMPANIES_LOADED'
export const KEEPER_RECON_UNMAPPED_LOADED = 'KEEPER_RECON_UNMAPPED_LOADED'
export const KEEPER_RECON_MAPPINGS_LOADED = 'KEEPER_RECON_MAPPINGS_LOADED'
